import BackofficeServicesRepository from '@/_shared/repositories/backoffice-services.repository';
import DownlineRank from '@/monitor/entities/downline-rank-report/downline-rank.entity';

class DownlineRankReportService {
  private boServicesRepository: BackofficeServicesRepository = new BackofficeServicesRepository();

  public getDownlineLeaders(repDID: number, rankId: number, page = 1): Promise<DownlineRank> {
    return this.boServicesRepository.get(`distributors/mentoring/${repDID}/${rankId}/${page}`, { withCredentials: true })
      .then(({ data }) => new DownlineRank(data));
  }

  public getDownlineRankIds(repDID: number): Promise<number[]> {
    return this.boServicesRepository.get(`distributors/mentoring/${repDID}`, { withCredentials: true })
      .then(({ data }) => (data.Boards || []).map((board: any) => board.rank_id));
  }
}

export default new DownlineRankReportService();
